import { createClient } from '@supabase/supabase-js';

// Supabase 프로젝트 URL과 API 키 (실제 프로젝트에서는 환경변수로 관리)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://firwvaemkqhjxzexhoot.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZpcnd2YWVta3Foanh6ZXhob290Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3NjY1NTcsImV4cCI6MjA2ODM0MjU1N30.V79PQsj1SJB5rnrDhtwLp3XyZ5MxTOPZR3v8PbTescU';

// Supabase 클라이언트 생성
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// 데이터베이스 테이블 타입 정의
export interface Database {
  public: {
    Tables: {
      registrations: {
        Row: {
          id: string;
          name: string;
          phone: string;
          gender: 'male' | 'female' | 'other';
          age_group: 'teen' | 'twenties' | 'thirties' | 'forties' | 'fifties' | 'sixties_plus';
          region: string;
          privacy_consent: boolean;
          marketing_consent: boolean;
          third_party_consent: boolean;
          registration_id: string;
          is_entered: boolean;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          name: string;
          phone: string;
          gender: 'male' | 'female' | 'other';
          age_group: 'teen' | 'twenties' | 'thirties' | 'forties' | 'fifties' | 'sixties_plus';
          region: string;
          privacy_consent: boolean;
          marketing_consent: boolean;
          third_party_consent: boolean;
          registration_id?: string;
          is_entered?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          name?: string;
          phone?: string;
          gender?: 'male' | 'female' | 'other';
          age_group?: 'teen' | 'twenties' | 'thirties' | 'forties' | 'fifties' | 'sixties_plus';
          region?: string;
          privacy_consent?: boolean;
          marketing_consent?: boolean;
          third_party_consent?: boolean;
          registration_id?: string;
          is_entered?: boolean;
          created_at?: string;
          updated_at?: string;
        };
      };
    };
  };
}

// 타입이 적용된 Supabase 클라이언트
export const supabaseClient = createClient<Database>(supabaseUrl, supabaseAnonKey); 